// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"95d706a0fa00b505a7db","3":"854b53de882bd28c1082","4":"b63286ead254b7e43fac","5":"def40108efc8ba6e9961"}[chunkId] + "";
};